import { useEffect, useState } from "react";
import './mobileapp.css';
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const MobileApp = ({ navbarHeight }) => {
    const { t } = useTranslation();
    const [coneSrc, setConeSrc] = useState("");
    const [androidStoreSrc, setAndroidStoreSrc] = useState("");
    const [iosStoreSrc, setIosStoreSrc] = useState("");

    // Navbar height handling is now done via CSS padding
    useEffect(() => {

        const fetchPictures = async () => {
            try {
                // 🔹 Hardcoded IDs for each image (adjust to your DB)
                const [coneId, androidId, iosId] = [8, 9, 10];

                // Call all three routes in parallel
                const [coneRes, androidRes, iosRes] = await Promise.all([
                    api.get(`/user/getwebsitepicture/${coneId}`),
                    api.get(`/user/getwebsitepicture/${androidId}`),
                    api.get(`/user/getwebsitepicture/${iosId}`)
                ]);

                setConeSrc(coneRes.data.picture);
                setAndroidStoreSrc(androidRes.data.picture);
                setIosStoreSrc(iosRes.data.picture);
            } catch (err) {
                console.error("Error fetching one or more pictures:", err);
            }
        };

        fetchPictures();
    }, [navbarHeight]);

    return (
        <div className="wrapper-mobileapp" id="app">
            <div className="mobileapp-everything" style={{ paddingTop: navbarHeight + 20 }}>
                <div className="mobileapp-description">
                    {coneSrc ? (
                        <img className="mobileapp-description-child" id="cone" src={coneSrc} alt="Barmatch" />
                    ) : (
                        <p>{t('LoadingPic')}</p>
                    )}
                    <div className="mobileapp-description-child" id="app-txt">
                        <p>
                            {t('AppInDevelopment')}
                        </p>
                    </div>
                </div>
                <div id="app-links">
                    {androidStoreSrc ? (
                        <img className="download-links" src={androidStoreSrc} alt="Barmatch" />
                    ) : (
                        <p>{t('LoadingPic')}</p>
                    )}
                    {iosStoreSrc ? (
                        <img className="download-links" src={iosStoreSrc} alt="Barmatch" />
                    ) : (
                        <p>{t('LoadingPic')}</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default MobileApp